import { types } from '../types/types';

// Navbar set theme
export const setNavbarTheme = (data) => ({
	type: types.setTheme,
	payload: data,
});

// Navbar reset settings
export const resetNavbarSettings = () => ({
	type: types.setResetUI,
});

// Get navbar status from local storage
export const getNavBarStatus = () =>
	localStorage.getItem('navbarThemePilu') || 'light';

// Set the status of the navbarTheme in local storage
export const setNavBarStatus = (value = null) => {
	if (value) {
		localStorage.setItem('navbarThemePilu', value);
	} else {
		const uiTheme = getNavBarStatus();
		localStorage.setItem('navbarThemePilu', uiTheme);
	}
};
